import React from "react";
import { Box, Grid, Label, StateLabel } from "@primer/components";
import "../../../scss/_hero.scss";
import Countdown from "../../../components/countdown/Countdown";

function Hero() {
  return (
    <>
      <Grid gridTemplateColumns="repeat(1, auto)">
        <Box mt={4}>
          <section className="fdb-block">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-md-6 mb-0">
                  <img
                    alt="hacktoberfest-banner"
                    className="img-fluid"
                    src="https://hacktoberfest.digitalocean.com/_nuxt/img/logo-hacktoberfest-full.f42e3b1.svg"
                  />
                  <Countdown />
                </div>
                <div className="col-12 col-md-6 col-lg-5 ml-md-auto mt-4">
                  <h1> OpenHackDay Sri Lanka</h1>
                  <br />
                  <p>
                    The following leaderboard shows the top github contributors
                    of OpenHackDay Sri Lanka 2021. You can join this leaderboard
                    by sending a Pull Request to any repository within following
                    Organizations.
                    <br />
                    <br />
                    <li>
                      <a href="https://github.com/GitHubExperts-LK">
                        GitHub Community Sri Lanka
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/sliit-foss">
                        SLIIT FOSS Community
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/fossnsbm">
                        NSBM FOSS Community
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/usj-foss">
                        J'pura FOSS Community
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/UCSC-Mozilla-Club">
                        UCSC Mozilla Club
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/IEEE-Student-Branch-of-IIT">
                        IEEE Student Branch of IIT
                      </a>
                    </li>
                    <br />
                    <b>
                      Scores will automatically updates when merging a Pull
                      request.
                    </b>
                    <br />
                    <b>
                      <StateLabel className="label" mt={3} status="pullMerged">
                        1 merged PR = 10 Points
                      </StateLabel>
                    </b>
                    <br /> <br />
                    <i>
                      <Label variant="medium" sx={{ bg: "grey", m: 1 }}>
                        Excluded repos: [{" "}
                        <a
                          href="https://github.com/fossnsbm/hactoberfest-2021"
                          target="_blank"
                          rel="noreferrer"
                        >
                          fossnsbm/hactoberfest-2021
                        </a>
                        ,{" "}
                        <a
                          href="https://github.com/usj-foss/FunnyAlgorithams"
                          target="_blank"
                          rel="noreferrer"
                        >
                          usj-foss/FunnyAlgorithams
                        </a>
                        ]
                      </Label>
                    </i>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </Box>
      </Grid>
    </>
  );
}

export default Hero;
